import Vue from 'vue';
import helpers from "./mixins/helpers";
if(document.getElementById('exam-page')) {
    let test = new Vue({
        el: "#exam-page",
        mixins: [helpers],
        data: {
            steps: questions.length,
            currentStep: 1,
            result: null,
            test:{
                questions:questions
            },
            netMessage: false,
            startTime: Date.now(),
            endTime: null,
            countdown: {
                enable: false,
                message: null,
                seconds: 0
            },
            load: false
        },
        methods: {
            nextStep(step) {
                var self = this;

                if (!step) {

                    if ($("#step-" + self.currentStep).find('input:checked').length > 0) {

                        self.currentStep++;

                    }
                } else {

                    self.currentStep = step;
                }

            },
            getResult() {

                if (this.netMessage === false) {
                    let self = this;
                    this.endTime = Date.now();
                    let $formData = $("#test").serialize();

                    $.ajax({
                        url: '/courses/exam/get-result',
                        dataType: "json",
                        method: 'POST',
                        data: {
                            data: $formData,
                            time: Math.floor((self.endTime - self.startTime) / 1000),
                            course_id:course_id
                        },
                        success: function (data) {

                            self.result = data;
                            self.countdown.enable = false;
                            self.countdown.seconds = 0;
                            self.load = false;

                            if (data.showReview) {
                                $('#reviewModal').modal('show').find('.modal-content').load('/reviews/new',{'code': data.reviewCode});
                            }

                        },
                        fail: function () {

                            throw new Error('Ошибка получении данных');

                        }
                    });

                }

            },
            countDown() {
                let self = this;
                if (this.countdown.seconds === 0 && this.countdown.enable === true) {
                    this.countdown.enable = false;
                    this.getResult();
                } else if (this.countdown.seconds > 0) {
                    let message = '';
                    let time = new Date(this.countdown.seconds * 1000);
                    if (time.getUTCHours() > 0) {
                        let hourse = time.getUTCHours();
                        message += hourse + ' ' + self.decOfNum(hourse, ['час', 'часа', 'часов']) + ' ';
                    }
                    if (time.getMinutes() > 0) {
                        let minute = time.getMinutes();
                        message += minute + ' ' + self.decOfNum(minute, ['минута', 'минуты', 'минут']) + ' ';
                    }
                    let seconds = time.getSeconds();
                    message += seconds + ' ' + self.decOfNum(seconds, ['секунда', 'секунды', 'секунд']);
                    this.countdown.seconds--;
                    this.countdown.message = message;

                }

            }
        }


    });

    Offline.on('confirmed-up',function () {
        test.netMessage = false;
    });

    Offline.on('confirmed-down',function () {
        test.netMessage = true;
    });

}
